import {Filter as FilterIcon} from "react-feather";
import SectionTitle from "./../SectionTitle";

import "../MenuNavegacao/MenuNavegacao.scss";
import React from "react";

function MenuBuscaTermo({
  isFiltroVisible,
  diarios,
  filtro,
  selecionarPoder,
  poderesOptions,
  esferasOptions,
  checkedState,
  handleOnChange,
  toggleMobileFilters,
}) {
  return (
    <React.Fragment>
      <h4 className="navigation-section-title-sm purple-text bold small-only">
        Diários Oficiais
      </h4>

      <SectionTitle
        title="Filtros"
        className="navigation-section-title purple-text bold uppercase large-only"
      />

      <span className="navigation-section-subtitle mb-1 large-only">
        {diarios.length}{" "}
        {diarios.length === 1 ? " resultado encontrado" : " resultados encontrados"}
      </span>

      <div style={{paddingRight: 12}}>
        <div className="filtro-sm-toggle mt-2">
          <div onClick={toggleMobileFilters}>
            <FilterIcon size={14} />
            <span>Filtros</span>
          </div>
        </div>
      </div>

      <div className={`${isFiltroVisible ? "filtro-sm-visible" : "filtro-sm-hidden"}`}>
        <div className="filtro-sidebar-wrapper">
          <h6 className="filtro-section-title-sm uppercase bold small-only">Poder</h6>
          <SectionTitle
            title="Poder"
            className="navigation-section-title bold my-3 large-only"
          />
          {poderesOptions.map((p, i) => {
            return (
              <div key={i} className="mt-1 campo-filtro-radio">
                <input
                  type="radio"
                  name="poderes"
                  id={`poderesRad-${p.key}`}
                  className="radio-button-filtro"
                  checked={p.key === filtro.poder}
                  onChange={(value) => {
                    selecionarPoder(p.key);
                    // goToPage();
                  }}
                />
                <label htmlFor={`poderesRad-${p.key}`}>
                  {p.key !== "mp" ? "Poder" : null} {p.label}
                </label>
              </div>
            );
          })}
        </div>

        <div className="filtro-sidebar-wrapper">
          <h6 className="filtro-section-title-sm uppercase bold small-only">
            Esfera Administrativa
          </h6>
          {/* Esfera administrativa */}
          <SectionTitle
            title="Esfera Administrativa"
            className="navigation-section-title bold my-3 large-only"
          />
          {esferasOptions.map((p, i) => {
            return (
              <div key={i} className="mt-1 campo-filtro-radio">
                <input
                  type="checkbox"
                  name="esferas"
                  value={p.key}
                  id={`esferasRad-${p.key}`}
                  className="radio-button-filtro"
                  checked={checkedState[i]}
                  onChange={() => {
                    handleOnChange(i);
                  }}
                />
                <label htmlFor={`esferasRad-${p.key}`}>{p.label}</label>
              </div>
            );
          })}
          {/* fim Esfera administrativa */}
        </div>
        <div style={{paddingRight: 12}}>
          <div className="filtro-sm-bottom">
            <div>
              <span onClick={toggleMobileFilters}>Fechar</span>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

export default MenuBuscaTermo;
